// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"33f482b1","824":"acea1b08"}[chunkId] + ".chunk.css";
};